/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var ErrorBlue = function ErrorBlue(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Error state icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['error--blue--paint0_linear', 'error--blue--paint1_linear', 'error--blue--paint2_linear', 'error--blue--paint3_linear', 'error--blue--paint4_linear', 'error--blue--paint5_linear', 'error--blue--clip0'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    viewBox: "0 0 140 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(gradientIds['error--blue--clip0'], ")")
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "0.47",
    d: "M61.1219 124.926l61.5951 35.301-.055-118.2955L61.1123 3.19086.329134 41.9315.0458984 160.227 61.1219 124.926z",
    fill: "url(#".concat(gradientIds['error--blue--paint0_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.34",
    d: "M.0556641 160.224L61.1674 124.862l61.5496 35.362-61.1115 35.362L.0556641 160.224z",
    fill: "url(#".concat(gradientIds['error--blue--paint1_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.4",
    d: "M122.716 160.224v4.414L61.5498 200l.0548-4.413 61.1114-35.363z",
    fill: "url(#".concat(gradientIds['error--blue--paint2_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.4",
    d: "M61.6046 195.587L61.5498 200 0 164.638l.0547596-4.414L61.6046 195.587z",
    fill: "url(#".concat(gradientIds['error--blue--paint3_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8023 109.181c-4.7894-2.78-9.1797-3.029-12.3228-1.192l-4.2905 2.482c3.143-1.837 7.4834-1.588 12.3228 1.192 9.5788 5.51 17.3117 18.814 17.2618 29.735 0 5.411-1.9457 9.234-5.0388 11.07l4.2905-2.482c3.0932-1.787 5.0389-5.609 5.0389-11.07.0499-10.921-7.6831-24.275-17.2619-29.735z",
    fill: "url(#".concat(gradientIds['error--blue--paint4_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5116 111.663c9.5788 5.51 17.3117 18.814 17.2619 29.735-.0499 10.921-7.7829 15.34-17.3617 9.879-9.5789-5.51-17.3118-18.814-17.2619-29.736.0499-10.97 7.7828-15.389 17.3617-9.878z",
    fill: "url(#".concat(gradientIds['error--blue--paint5_linear'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5628 143.246c-.7836-.468-1.3581-.988-1.7238-1.611-.3656-.624-.5223-1.248-.5223-1.923v-.624c0-.676.1567-1.092.5223-1.3.3657-.207.9402-.103 1.7238.364.7835.468 1.3581.988 1.6715 1.612.3134.623.5224 1.247.5224 1.923v.623c0 .676-.1568 1.092-.5224 1.3-.3134.156-.888.052-1.6715-.364zm-.7313-9.616l-1.1492-9.927v-6.289l3.7609 2.183v6.289l-1.0969 8.628-1.5148-.884z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--blue--paint0_linear'],
    x1: "61.368",
    y1: "46.6974",
    x2: "61.368",
    y2: "203.538",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F2FF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.0955362",
    stopColor: "#E9E8FF",
    stopOpacity: "0.0479574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.5112",
    stopColor: "#B5C1FF",
    stopOpacity: "0.2566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.8241",
    stopColor: "#94A9FF",
    stopOpacity: "0.4137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9961",
    stopColor: "#88A0FF",
    stopOpacity: "0.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--blue--paint1_linear'],
    x1: "122.735",
    y1: "160.207",
    x2: "0.0425371",
    y2: "160.207",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9986",
    stopColor: "#97B4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--blue--paint2_linear'],
    x1: "61.5452",
    y1: "180.108",
    x2: "122.734",
    y2: "180.108",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9987",
    stopColor: "#BCC4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--blue--paint3_linear'],
    x1: "0",
    y1: "180.109",
    x2: "61.5868",
    y2: "180.109",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D96FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#97C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--blue--paint4_linear'],
    x1: "62.1334",
    y1: "131.512",
    x2: "62.1267",
    y2: "106.811",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9BCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9987",
    stopColor: "#F1F2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--blue--paint5_linear'],
    x1: "70.2589",
    y1: "163.564",
    x2: "70.3934",
    y2: "109.292",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9986",
    stopColor: "#E3E5FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: gradientIds['error--blue--clip0']
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h140v200H0z"
  }))));
};
ErrorBlue.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var ErrorBlue$1 = ErrorBlue;

export { ErrorBlue$1 as default };
